import { CustomPageHeading } from "../../components/CustomPageHeading/CustomPageHeading";
import { useUiTranslator } from "../../hooks/useUiTranslator";
import { useGetApiEasyAdministrationArea } from "../../openapi/backendApi";
import { theme as FooterTheme } from "../../theme/footerTheme";
import { customPalette } from "../../theme/theme";
import { FooterTextLabel } from "../renderer/components/FooterTextLabel/FooterTextLabel";

import { JSX } from "react";

import { Box, Container, ThemeProvider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useSearch } from "@tanstack/react-router";

import { PreselectorBtn } from "./PreselectorBtn";

export const ConfigurationPreselector = (): JSX.Element => {
  const t = useUiTranslator();

  const { administrationArea } = useSearch({
    from: "/configurator",
  });

  const { data: administrationAreaData } = useGetApiEasyAdministrationArea();
  const adminArea = administrationArea
    ? administrationArea
    : administrationAreaData?.data.string;

  return (
    <Box>
      <Container>
        <CustomPageHeading
          text={t(
            "CustomApp:title.configurator.preselection",
            "Gear ProSelect",
          )}
          //subtitle={item.name}
        />
        <Box mb={6}>
          <Typography variant="body1">
            {t(
              "CustomApp:preselector.subcaption.text",
              "Find your Product based on your needs.",
            )}
          </Typography>
        </Box>
        {!!adminArea ? (
          <Grid container spacing={4}>
            <PreselectorBtn
              label={t(
                "CustomApp:title.configurator.appCalc",
                "Application Calculator",
              )}
              description={t(
                "CustomApp:description.configurator.appCalc",
                "Size the product with data from your equipment",
              )}
              imgSrc="/img/Application.png"
              cfgObjectId="CFG_APPLICATION"
              administrationArea={adminArea}
            />
            <PreselectorBtn
              label={t(
                "CustomApp:title.configurator.productConfigurator",
                "Product Configurator",
              )}
              description={t(
                "CustomApp:description.configurator.productConfigurator",
                "Size your produt with drive data",
              )}
              imgSrc="/img/Professional.png"
              cfgObjectId="CFG_PROFESSIONAL"
              administrationArea={adminArea}
            />
          </Grid>
        ) : (
          <span>Please reload the page. Invalid administration area.</span>
        )}
      </Container>
      <ThemeProvider theme={FooterTheme}>
        <Box
          mt="16px"
          sx={{
            position: "fixed",
            display: "flex",
            boxShadow: "0 -15px 15px 0 rgba(0,0,0,.125)",
            backgroundColor: customPalette.primary.dark,
            bottom: 0,
            left: 0,
            right: 0,
            minHeight: "64px",
          }}
        >
          <FooterTextLabel />
        </Box>
      </ThemeProvider>
    </Box>
  );
};
